import axios from 'axios';

export const state = {}

export const mutations = {}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    console.log(state.session);
    return state.session
  },
}
export const actions = {

  async widgets({ commit, dispatch, getters }, date = null) {

    try{

      const result  = await axios.post('dashboard/widget',
        {
          date
        }
      );

      return { success: true, message: 'Widget data', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async walletWidgets({ commit, dispatch, getters }, date = null) {

    try{

      const result  = await axios.post('dashboard/wallet',
        {
          date
        }
      );

      return { success: true, message: 'Widget data', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async graphs({ commit, dispatch, getters }, date = null) {

    try{

      const result  = await axios.post('dashboard/graph',
        {
          date
        }
      );

      return { success: true, message: 'Graphs', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async topSelling({ commit, dispatch, getters }, date = null) {

    try{

      const result  = await axios.post('dashboard/top-selling',
        {
          date
        }
      );

      return { success: true, message: 'Top selling', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async recentOrders({ commit, dispatch, getters }, date = null) {

    try{
      const result  = await axios.post('orders/list',
        {
          where: null,
          search: null,
          strict: true,
          pagination: {
            page: 1,
            rowsPerPage: 6,
            sortBy: "id",
            descending: true
          }
        });

      return { success: true, message: 'Orders list', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async monthGraph({ commit, dispatch, getters }, date = null) {

    try{
      const result  = await axios.post('dashboard/month-graph', {date});

      return { success: true, message: 'Month versus graph!', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },
}